export function formatExcelDate(value: any): string | null {
  if (value === null || value === undefined || value === "") return null
  // Если это число (Excel date serial)
  if (typeof value === "number") {
    if (value <= 0 || value > 100000) return null
    // Excel epoch: Jan 0, 1900 = 2 (with Mon-Tue bug: Jan 1 = 1)
    const date = new Date((value - 2) * 86400 * 1000)
    if (isNaN(date.getTime())) return null
    const dd = String(date.getDate()).padStart(2, "0")
    const mm = String(date.getMonth() + 1).padStart(2, "0")
    const yyyy = date.getFullYear()
    return `${dd}.${mm}.${yyyy}`
  }
  // Строка — пробуем несколько форматов
  const str = String(value).trim()
  if (!str) return null

  // already dd.mm.yyyy or dd-mmm-yyyy / dd.mm.yyyy
  const dotRe = /^(\d{1,2})[.\/](\d{1,2})[.\/](\d{4})$/
  let m = str.match(dotRe)
  if (m) {
    const dd = m[1].padStart(2, "0")
    const mm = m[2].padStart(2, "0")
    return `${dd}.${mm}.${m[3]}`
  }

  // ISO  yyyy-mm-dd
  const isoRe = /^(\d{4})[.\/-](\d{1,2})[.\/-](\d{1,2})$/
  m = str.match(isoRe)
  if (m) {
    const dd = m[3].padStart(2, "0")
    const mm = m[2].padStart(2, "0")
    return `${dd}.${mm}.${m[1]}`
  }

  // fallback — вернуть как есть
  return str
}
